import React, { useRef, useEffect, useState } from 'react';
import { CLIENTS, COLORS } from '../../data/siteData';

const ClientsSection = () => {
  const scrollRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let animationId;
    let scrollPosition = 0;

    const scroll = () => {
      if (!isHovered) {
        scrollPosition += 0.5;
        if (scrollPosition >= scrollContainer.scrollWidth / 2) {
          scrollPosition = 0;
        }
        scrollContainer.scrollLeft = scrollPosition;
      }
      animationId = requestAnimationFrame(scroll);
    };

    animationId = requestAnimationFrame(scroll);

    return () => {
      cancelAnimationFrame(animationId);
    };
  }, [isHovered]);

  // Duplicate logos for infinite scroll effect
  const duplicatedLogos = [...CLIENTS.logos, ...CLIENTS.logos];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" style={{ color: COLORS.dark }}>
            {CLIENTS.title}
          </h2>
          <p className="text-lg mb-8" style={{ color: COLORS.gray }}>
            {CLIENTS.subtitle}
          </p>
          <h3 className="text-xl font-semibold" style={{ color: COLORS.dark }}>
            {CLIENTS.subheading}
          </h3>
        </div>

        {/* Logo Carousel */}
        <div 
          className="overflow-hidden"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div 
            ref={scrollRef}
            className="flex gap-8 overflow-x-hidden"
            style={{ scrollBehavior: 'auto' }}
          >
            {duplicatedLogos.map((logo, index) => (
              <div 
                key={index}
                className="flex-shrink-0 w-24 h-24 flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-300"
              >
                <img
                  src={logo.image}
                  alt={logo.name}
                  className="max-w-full max-h-full object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
